<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editDepartment"
          class="fixed center-h-v bg-white rounded-md h-full md:h-auto shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Department</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="">
              <div class="grid grid-cols-2 gap-5 items-center">
                <div class="text-sm">
                  <label class="block pb-1 text-xs">Name</label>
                  <input
                    type="text"
                    name="department name"
                    v-model="departmentToEdit.Name"
                    id=""
                    class="p-2 bg-gray-200 rounded-full w-full"
                    autofocus
                  />
                </div>

                <div class="text-sm">
                  <label class="block pb-1">Company Name</label>
                  <el-select
                    filterable
                    class="bg-gray-200 rounded-full w-full border-none"
                    v-model="departmentToEdit.LocationName"
                    @change="findBranchesByLocationId"
                    placeholder="Enter a company"
                  >
                    <el-option
                      v-for="location in locations"
                      :key="location.Name"
                      :label="location.Name"
                      :value="location.Name"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Branch</label>
                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="departmentToEdit.BranchName"
                  @change="findBranchByName"
                  placeholder="Enter a branch"
                >
                  <el-option
                    v-for="branch in branchesToSelect"
                    :key="branch.Id"
                    :label="`${branch.Name} - ${branch.Location}`"
                    :value="`${branch.Name} - ${branch.Location}`"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="text-sm col-span-2">
                <label class="block pb-1">Department Manager</label>

                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="departmentToEdit.DepartmentManagerId"
                  placeholder="Enter a manager name"
                >
                  <el-option
                    v-for="jobTitle in jobTitles"
                    :key="jobTitle.Id"
                    :value="jobTitle.Id"
                    :label="jobTitle.Name"
                  >
                    {{ jobTitle.Name }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
export default {
  name: "CompanySetupEditDepartment",
  props: ["showEditDepartment", "departmentToEdit", "reload"],
  components: { Loader },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      managerId: "",
      saved_locations: [],
      locations: [],

      managers: [],
      branches: [],
      departments: [],
      employees: [],
      isBranchDisabled: true,
      isLocationDisabled: true,
      branchesToSelect: [],
      departmentsToSelect: [],
      locationsToSelect: [],
      jobTitles: [],
      info: {
        Id: "",
        LocationId: "",
        BranchId: "",
        DepartmentManager: "",
        Name: "",
      },
      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },
  created() {
    //console.log(this.departmentToEdit)

    this.getLocations();
    this.getBranches();
    this.getEmployees();
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  watch: {
    showEditDepartment(newState) {
      if (newState) {
        this.getJobTitles();
      }
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    // /{organization}/setup/location/v1/request
    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.locations = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.jobTitles = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getBranches() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          this.branches = response.data.Data.map((branch) => {
            return { ...branch, Branch: branch.Name };
          });
          //console.log(this.branches)
        });
    },

    findBranchByName(branch) {
      const [branchName, LocationName] = branch.split(" - ");
      //console.log(branchName, LocationName, this.branchesToSelect)
      this.departmentToEdit.BranchId = this.branchesToSelect.filter(
        (branch) =>
          branch.Name.trim() == branchName &&
          branch.Location.trim() == LocationName
      )[0].Id;
      //console.log(this.departmentToEdit.BranchId, this.branchesToSelect)
    },
    findBranchesByLocationId(l) {
      //console.log(l)
      // this.info.Branch = null;
      //console.log(l, this.branches, this.locations)
      this.branchesToSelect = this.branches.filter(
        (branch) => branch.Location.trim().toLowerCase() === l.toLowerCase()
      );
      this.departmentToEdit.LocationId = this.locations.find(
        (location) =>
          location.Name.trim().toLowerCase() === l.trim().toLowerCase()
      ).Id;
      //console.log(this.info.LocationId)
      if (this.branchesToSelect.length) {
        this.isBranchDisabled = false;
        this.isLocationDisabled = false;
      } else {
        this.info.BranchId = null;
        this.isBranchDisabled = true;
        this.isLocationDisabled = true;
        this.create_error = `No branches at ${location.Name} yet. Create one first before proceeding`;

        setTimeout(() => {
          this.create_error = null;
        }, 3000);
      }
      //console.log(location, this.branchesToSelect)
    },
    findDepartmentManagers(selectedManager) {
      const [empNo, EmpName] = selectedManager.split(" - ");
      EmpName;

      this.departmentToEdit.DepartmentManagerId = this.managers.filter(
        (manager) => manager.EmployeeNo.trim() == empNo
      )[0].Id;
      // this.info.DepartmentManager = this.departmentToEdit.DepartmentManagerId
    },
    editDepartment() {
      this.loading = true;
      const [, EmpName] = this.departmentToEdit.DepartmentManager.split(" - ");
      const [BranchName] = this.departmentToEdit.BranchName
        ? this.departmentToEdit.BranchName.split(" - ")
        : "";
      EmpName;
      this.departmentToEdit.BranchName = BranchName;
      this.departmentToEdit.DepartmentManager =
        this.departmentToEdit.DepartmentManagerId;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/edit`,
          JSON.stringify(this.departmentToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.close();
              this.reload();
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
        );
    },

    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          //console.log(response.data)
          this.employees = response.data.Data;
          this.managers = response.data.Data;
          //console.log(this.employees)
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
